import React, { useState, useEffect } from "react";
import TableViewSearch from "../../../CustomComponent/TableViewSearch";
import TableView from "../../../CustomComponent/TableView";
import useStyles from "../../../../styles";
import { Button, Paper, Popover, Tooltip, withStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import ArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { ReactComponent as ActiveIcon } from "../../../images/commonicon/activeicon.svg";
import { ReactComponent as InactiveIcon } from "../../../images/commonicon/inactiveicon.svg";
import { Link, useNavigate } from "react-router-dom";
import LearnerTableViewSearch from "../../../CustomComponent/LearnerTableViewSearch";
import { decryptData } from "../../../../crypto";
import axios from "axios";
import Box from "@mui/material/Box";
import { useParams, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import MultiSelectTable from "./MultiSelectTable";

function ViewTotalApplication() {
  const { name, rowId } = useParams();
  const location = useLocation();
  const classes = useStyles();
  const style = [
    {
      height: "maxh67",
      style: "viewtable",
    },
  ];
  const [anchorEl, setAnchorEl] = useState(null);
  const popoveropen = Boolean(anchorEl);
  const id = popoveropen ? "simple-popover" : undefined;
  const [selectedRowId, setSelectedRowId] = useState();
  const [center, setCenter] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const [cources, setCources] = useState([]);
  const navigate = useNavigate();
  const [selectedCource, setSelectedCource] = useState("");
  const [selectedBatch, setSelectedBatch] = useState("");
  const handleClick = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId);
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleButtonClick = (type, rowId, code) => {
    if (type === "editregistrationlink") {
      navigate(`/admin/editregistrationlink/${rowId}`, {
        state: { code },
      });
    }
  };

  const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }))(Tooltip);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/registration_link/all/candidate_details/${location?.state?.code}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      setCources(response.data.applications);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Function to delete a book
  const deleteDataOfRow = async (rowId) => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));
      const response = await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/registration_link/${rowId}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );

      console.log("Registration Link deleted:", response.data);
      fetchData();
      handleClose();
      toast.success("Registration Link deleted successfully");
      const updateddatatata = cources.filter((data) => data.id !== rowId);
      setCources(updateddatatata);
    } catch (error) {
      toast.error("Registration Link is not deleted");
      console.error("Error deleting data: ", error);
    }
  };

  const handleStatus = (iddd, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";

    const data = {
      registration: {
        active_status: newStatus,
        id: iddd,
      },
    };

    axios
      .put(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/registration_link/status`,
        data,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      )
      .then((response) => {
        console.log("Registration Link status changed successfully", response);
        fetchData();
        toast.success("Registration Link status changed successfully");
        handleClose();
      })
      .catch((error) => {
        console.error("Error changed Registration Link status:", error);
        toast.error("Cource status is not changed");
      });
  };

  const rows = cources?.map((d) => ({
    id: d.id ? d.id : "N/A",
    candidate_name: d.candidate ? d?.candidate?.full_name : "N/A",
    father_name: d.candidate ? d?.candidate?.father_name : "N/A",
    mobile_number: d.candidate ? d?.candidate?.phone : "N/A",
    email: d.candidate ? d?.candidate?.email : "N/A",
    dob: d.candidate ? d?.candidate?.dob : "N/A",
    category: d.candidate ? d?.candidate?.category_type : "N/A",
    payment_status: d.razorpay_payment_status
      ? d?.razorpay_payment_status
      : "N/A",
  }));

  const filteredRows = rows
    .filter((d) => {
    const query = searchQuery.toLowerCase();
    const isNameMatch = d.candidate_name.toLowerCase().includes(query);
    const isEmailMatch = d.email.toLowerCase().includes(query);
    return isNameMatch || isEmailMatch; // Match either name or email
  })
    .map((row, index) => ({
      ...row,
      srno: index + 1,
    }));

  const columns = [
    {
      field: "srno",
      headerName: "#",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 70,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "candidate_name",
      headerName: "Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      flex: 1,
      minWidth: 150,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (cellValues) => (
        <div
          className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter}`}
        >
          {cellValues.value}
        </div>
      ),
    },
    {
      field: "father_name",
      headerName: "Father Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      flex: 1,
      minWidth: 150,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "mobile_number",
      headerName: "Mob. Number",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      flex: 1,
      minWidth: 130,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "email",
      headerName: "Email",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      flex: 1,
      minWidth: 200,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "dob",
      headerName: "DOB",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      flex: 1,
      minWidth: 120,
      sortable: false,
      disableColumnMenu: true,
    },

    {
      field: "category",
      headerName: "Category",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      flex: 1,
      minWidth: 120,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "payment_status",
      headerName: "Payment Status",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      flex: 1,
      minWidth: 120,
      sortable: false,
      disableColumnMenu: true,
    },
  ];

  const Heading = [
    {
      id: 1,
      inputplaceholder: "Search Name & Email", 
      exportimport: "yes",
      hideImportButton: "yes",
    },
  ];
  const menuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    disablePortal: true,
  };
  const handleCenterChange = (event) => {
    setSelectedCenter(event.target.value);
  };
  const handleCourceChange = (event) => {
    setSelectedCource(event.target.value);
  };
  const handleBatchChange = (event, newValue) => {
    setSelectedBatch(event.target.value);
  };
  let [Id, setId] = useState("");

  const handleCheckboxClick = (selectedIDs) => {
    setId(selectedIDs);
  };
  return (
    <>
      <ToastContainer />
      <div
        className={`${classes.bgwhite} ${classes.alignitemsend} ${classes.justifyspacebetween} ${classes.inputpadding} ${classes.inputborder} ${classes.boxshadow3} ${classes.borderradius6px}  ${classes.mt1}`}
      >
        <Box className={`${classes.p0_5} ${classes.ml1}`}>
          <Box className={`${classes.ml1} ${classes.fw600}`}>
            Form Name : {location?.state?.data?.course_name}
          </Box>
          <Box className={`${classes.ml1} ${classes.fw600}`}>
            Exam Name : {location?.state?.data?.name}
          </Box>
        </Box>
        <LearnerTableViewSearch
          fetchData={fetchData}
          location={location}
          // fetchData={[]}
          learner={true}
          decryptedToken={decryptedToken}
          Heading={Heading}
          onSearch={handleSearch}
        />
        {/* <TableViewSearch Heading={Heading} onSearch={handleSearch} /> */}
        {/* <TableView columns={columns} rows={filteredRows} Heading={style} /> */}
        <MultiSelectTable
          menuProps={menuProps}
          columns={columns}
          filteredRows={filteredRows}
          handleStatus={handleStatus}
          center={center}
          selectedCenter={""}
          handleCenterChange={handleCenterChange}
          cources={cources}
          selectedCource={""}
          handleCourceChange={handleCourceChange}
          batches={[]}
          selectedBatch={selectedBatch}
          handleBatchChange={handleBatchChange}
          handleCheckboxClick={handleCheckboxClick}
        />
      </div>
    </>
  );
}
export default ViewTotalApplication;
